import React from 'react';
import RegisterForm from '../../components/RegisterForm/RegisterForm';
import { Container } from 'reactstrap';

const Register = () => {
  return (
    <Container>
      <RegisterForm />
    </Container>
  );
};

export default Register;
